module.exports = __webpack_public_path__ + "img/KwanzaaFresh-Logo.72ee64aa.svg";